import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import HomePage from "@/pages/HomePage";
import QualifyPage from "@/pages/QualifyPage";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2 }}>
      <BrowserRouter>
        <div className="grain-overlay" aria-hidden="true" />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/book" element={<QualifyPage />} />
        </Routes>
        <Footer />
        <ChatWidget />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
